import { motion } from 'framer-motion';
import { type ReactNode } from 'react';

interface IFlipCardProps {
  isFlipped: boolean;
  front: ReactNode;
  back: ReactNode;
  width?: number;
  height?: number;
}

export const FlipCard = ({ isFlipped, front, back, width = 438, height = 256 }: IFlipCardProps) => (
  <motion.div
    animate={{ rotateY: isFlipped ? 180 : 0 }}
    transition={{ duration: 0.6 }}
    style={{ width, height, position: 'relative', transformStyle: 'preserve-3d' }}
  >
    <div style={{ position: 'absolute', inset: 0, backfaceVisibility: 'hidden' }}>{front}</div>
    <div style={{ position: 'absolute', inset: 0, backfaceVisibility: 'hidden', transform: 'rotateY(180deg)' }}>
      {back}
    </div>
  </motion.div>
);
